<template>
  <div
    class="md:container md:mx-auto  flex flex-col items-center font-Almarai relative overflow-x-hidden"
  >
    <LogoSvg class="absolute" />

    <div class="flex justify-center items-center w-3/12  h-36">
      <img src="@/assets/logo-1.webp" alt="logo" class="w-28" />
    </div>
    <!-- Main Content -->

        <div class=" my-3 mx-2  text-center flex justify-center">
          <p
            class="text-gray-400 md:text-md text-sm max-w-md text-center font-Tajawal"
          >
            تأكد من إدخال نفس رقم الهاتف الذي تستخدمه داخل التطبيق
          </p>
        </div>

        <div
          class=" max-w-3xl flex flex-col justify-center items-center space-x-2 mx-2  w-full md:my-3"
        >
          <form class="md:w-8/12 w-full mx-auto" dir="">
            <div class="relative">
              <select
                dir="rtl"
                id="countries"
                v-model="operator"
                class="custom-select bg-gray-900 border border-[#9d2890] text-gray-200 md:text-md text-sm rounded-lg focus:ring-[#9d2890] focus:border-[#9d2890] block w-full p-2.5"
              >
                <option class="" value="sa" selected>السعودية</option>
                <option class="" value="ae">الإمارات</option>
              </select>
            </div>
          </form>

          <div
            class="my-3 flex justify-between space-x-3 md:w-10/12 w-full md:px-12 px-1"
            v-if="operator === 'sa'"
          >
            <div
              class="form-group w-1/2 rounded-md p-6 relative bg-[#111220] flex flex-col items-center justify-center px-8 cursor-pointer"
              :class="
                selectedProvider == 'mobiley'
                  ? ' border-2 border-[#9d2890]'
                  : ''
              "
              @click="showOperator(0)"
            >
              <span
                v-if="selectedProvider === 'mobiley'"
                class="size-5 bg-[#9d2890] absolute top-2 right-2 rounded-full text-center md:text-md text-sm"
                ><span class="mt-3">{{ "✓" }}</span></span
              >

              <label for="stc" class="custom-radio-label text-white mx-2 my-4"
                >موبايلي
              </label>

              <img src="@/assets/tele/mobily.png" class="my-2" alt="logo" />
            </div>
            <div
              class="form-group w-1/2 rounded-md p-6 relative bg-[#111220] flex flex-col items-center justify-center px-8 cursor-pointer"
              :class="
                selectedProvider == 'stc' ? ' border-2 border-[#9d2890]' : 'border border-green-400'
              "
              @click="showOperator(1)"
            >
              <span
                v-if="selectedProvider === 'stc'"
                class="size-5 bg-[#9d2890] absolute top-2 right-2 rounded-full text-center md:text-md text-sm"
                ><span class="mt-3">{{ "✓" }}</span></span
              >

              <label for="stc" class="custom-radio-label text-white mx-2 my-4">STC </label>

              <img src="@/assets/tele/stc.webp" class="my-2" alt="logo" />
            </div>
          </div>
          <div
            class="my-3 flex justify-between space-x-3 md:w-10/12 w-full md:px-12 px-1"
            dir="rtl"
            v-if="operator === 'ae'"
          >
            <div
              class="form-group w-1/2 rounded-md p-6 relative bg-[#111220] flex flex-col items-center justify-center px-8 cursor-pointer"
              :class="
                selectedProvider == 'etisalate'
                  ? ' border-2 border-[#9d2890]'
                  : ''
              "
              @click="showOperator(2)"
            >
              <span
                v-if="selectedProvider === 'etisalate'"
                class="size-5 bg-[#9d2890] absolute top-2 right-2 rounded-full text-center md:text-md text-sm"
                ><span class="mt-3">{{ "✓" }}</span></span
              >

              <label for="stc" class="custom-radio-label text-white mx-2 my-4"
                >إتصالات
              </label>

              <img
                src="@/assets/tele/etisalat.webp"
                class="my-2"
                alt="etisalat"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="max-w-lg m-3 pb-6 mx-2  relative md:w-8/12 md:mt-2 mt-1 md:mx-auto">
        <button
          @click.prevent="redirectUserToProvider"
          class="inline-flex justify-center items-center gap-2 w-full bg-[#9d2890] text-gray-100 rounded-md py-3"
        >
          <span v-show="!loaded"> المتابعة</span>
          <div role="status" v-show="loaded">
            <spinner-view />
          </div>
        </button>
      </div>

</template>

<script>
import SpinnerView from "@/components/SpinnerView.vue";
import { useToast } from "vue-toastification";
import LogoSvg   from "@/components/svg/LogoSvg.vue";

export default {
  components: { SpinnerView, LogoSvg },
  data() {
    return {
      loaded: false,
      isMobile: false,
      selectedProvider: null,
      StripePlan: null,
      operator: "sa",
      toast: useToast(),

      providers: {
        mobiley: "https://sa.nasna.tv/auth/mobily/subscribe",
        stc: "https://stc.nasna.tv/auth/subscribe",
        etisalate: "https://ae.nasna.tv/subscribe",
      },
      activeTab: "stripe",
      yearly: null,
    };
  },
  methods: {
    showOperator(id) {
      switch (id) {
        case 0:
          this.selectedProvider = "mobiley";
          break;
        case 1:
          this.selectedProvider = "stc";
          break;

        case 2:
          this.selectedProvider = "etisalate";
          break;

        default:
          this.selectedProvider = "mobiley";
      }
    },
    redirectUserToProvider() {
      this.loaded = true;

      if (this.providers[this.selectedProvider]) {
        window.location.href = this.providers[this.selectedProvider];
      } else {
        this.toast.error("يرجى إختيار شركة الإتصالات");
      }
      this.loaded = false;
    },
  },
};
</script>

<style scoped>
.width-height {
  width: 900px;
  height: auto;
}

.xxsm {
  width: 255px;
}

.w-btn {
  width: 290px;
  align-self: right;
}

.btn-color {
  background-color: #9d2890;
}

.tab {
  transition: background-color 0.3s ease;
}

.tab.active {
  background-color: #fff;
  border-radius: 20px;
  color: #9d2890;
}
</style>
